/** Evaluate headers, resolving any function-valued headers */
export const evaluateHeaders = async (headers) => {
    const evaluatedHeaders = {};
    for (const [key, value] of Object.entries(headers)) {
        if (typeof value === 'function') {
            const headerVal = await value();
            if (headerVal != null) {
                evaluatedHeaders[key] = headerVal;
            }
        }
        else {
            evaluatedHeaders[key] = value;
        }
    }
    return evaluatedHeaders;
};
/** Fetch all pages of a paginated GraphQL query */
export const fetchAllItems = async ({ fetchPage, selectItems, getNextToken, onError, }) => {
    if (!fetchPage || typeof fetchPage !== 'function') {
        throw new Error('fetchPage must be a function');
    }
    try {
        const firstPage = await fetchPage(null);
        const items = [...selectItems(firstPage)];
        let nextToken = getNextToken(firstPage);
        while (nextToken) {
            const page = await fetchPage(nextToken);
            items.push(...selectItems(page));
            nextToken = getNextToken(page);
        }
        return items;
    }
    catch (e) {
        if (typeof onError === 'function') {
            onError(e);
        }
        throw e;
    }
};
//# sourceMappingURL=utils.js.map